import styled from 'styled-components/macro'

export const HeroContainer = styled.div`
  position: relative;
`

export const Hero = styled.div`
  position: relative;
  z-index: 100;
  background: url('${(props) => (props.image ? props.image : null)}');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center top;
  height: 385px;
  width: 100%;
  transition: 0.3s ease;
  &::after {
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    z-index: 101;
  }
  @media (min-width: 1024px) {
    height: 624px;
  }
`
